var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loading-page"},[_c('div',{staticClass:"spinner spinner--rotate-square-5",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner",style:(_vm.innerStyles)},[_c('span',{staticClass:"load3 one"}),_vm._v(" "),_c('span',{staticClass:"load3 two"}),_vm._v(" "),_c('span',{staticClass:"load3-center"})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }